import { render, staticRenderFns } from "./PromoMailCheckboxPanel.vue?vue&type=template&id=69d68b8e&"
import script from "./PromoMailCheckboxPanel.vue?vue&type=script&lang=ts&"
export * from "./PromoMailCheckboxPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports